<script>
import ListInstructorsComponent from '../../features/lists/ListInstructorsComponent';
import ModalInstructorView from '../modals/ModalInstructorView';
import ModalImportView from '../../../shared/views/ModalImportView';


export default {
  name: 'ListInstructorView',
  components: {
    'modal-instructor-view': ModalInstructorView,
    'modal-import': ModalImportView,
  },
  extends: ListInstructorsComponent,
};
</script>

<template>
  <div class="list-body">
    <el-row :gutter="20" class="section-ctrl">
    <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14" class="header-right">
        <el-button-group class="btn-grp-drp">
          <el-button
            type="primary"
            size="small"
            class="btn-primary"
            icon="el-icon-circle-plus"
            :disabled="!onCanCreate(modulePermissions)"
            @click="onCreate"
          >
            Crear Profesor
          </el-button>
          <el-dropdown>
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i class="fa fa-ellipsis-v" /> <span class="hidden-xs-only">M&aacute;s Opciones</span>
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light"
                    icon="el-icon-upload"
                    :disabled="!onCanCreate(modulePermissions)"
                    @click="onShowImport"
                  >
                    Importar Profesores
                  </el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-button
                    size="small"
                    class="btn-primary-light btn-primary-full"
                    :disabled="!onCanRead(modulePermissions)"
                    @click="onExportToExcel()"
                  >
                    <i
                      class="fa fa-file-excel-o"
                      aria-hidden="true"
                    /> Exportar
                    Excel
                  </el-button>
                </el-dropdown-item>
              <!--<el-dropdown-item>
                <el-button size="small" class="btn-white">
                  <i class="fa fa-file-pdf-o" aria-hidden="true"></i> Exportar PDF
                </el-button>
              </el-dropdown-item>-->
              </el-dropdown-menu>
            </template>
          </el-dropdown>
          <el-dropdown
            trigger="click"
            :hide-on-click="false"
            popper-class="filter-dropdown-popper"
          >
            <el-button
              size="small"
              class="btn-primary-light"
            >
              <i
                class="fa fa-filter"
                aria-hidden="true"
              /> <span class="hidden-xs-only">Filtrar Por</span> <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <!--<el-dropdown-item>
                <el-select size="small" v-model="parentFilter" filterable remote clearable placeholder="Padre..."
                :remote-method="onSearchInstructor" @change="onAllFilterChange(parentFilter.id, 'Parent')" @focus="onFocusInstructor"
                value-key="id">
                  <el-option v-for="item in parents" :key="item.id" :label="item.name" :value="item"></el-option>
                </el-select>
              </el-dropdown-item>-->
                <el-dropdown-item>
                  <el-select
                    v-model="filterOptions.status"
                    size="small"
                    clearable
                    placeholder="Estado..."
                    value-key="id"
                    @change="onAllFilterChange(filterOptions.status, 'Status')"
                  >
                    <el-option
                      v-for="item in userStatuses"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-button-group>
    </el-col>
    <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" class="header-left search-inputs-row">
        <el-input
          v-model="filterOptions.fullNameFilter"
          size="small"
          placeholder="Buscar Nombre..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(filterOptions.fullNameFilter, 'FullName')"
        />
        <el-input
          v-model="filterOptions.emailFilter"
          size="small"
          placeholder="Buscar Correo..."
          suffix-icon="el-icon-search"
          @keyup.enter="onAllFilterChange(filterOptions.emailFilter, 'Email')"
        />
    </el-col>
    </el-row>

    <el-table
      v-loading="isListLoading"
      :data="collection"
      empty-text="No se encontraron resultados."
      element-loading-spinner="el-icon-loading"
      :element-loading-text="listLoadingMessage"
    >
      <el-table-column
        label=""
        width="70"
      >
        <template #default="scope">
          <div>
            <el-avatar :src="mapProfileImage(scope.row.userProfile)" />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="NOMBRE"
        min-width="350"
      >
        <template #default="scope">
          <div>
            {{ scope.row.userProfile ? scope.row.userProfile.firstName : '' }} {{ scope.row.userProfile ? scope.row.userProfile.lastName : '' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="CORREO"
        min-width="350"
      >
        <template #default="scope">
          <div>
            <el-tag
              type="info"
              effect="plain"
            >
              {{ scope.row.userProfile ? scope.row.userProfile.email : '' }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="REDES SOCIALES"
        width="160"
        align="center"
      >
        <template #default="scope">
          <ul class="tutor_social_links">
            <li>
              <a
                v-if="hasFacebookPage(scope.row)"
                :href="scope.row.pageUrlFacebook"
                class="fb"
                target="_blank"
              ><i class="fab fa-facebook-f" /></a>
            </li>
            <!-- <li>
              <a href="#" class="tw"><i class="fab fa-twitter"></i></a>
            </li> -->
            <li>
              <a
                v-if="hasInstagramPage(scope.row)"
                :href="scope.row.pageUrlInstagram"
                class="in"
                target="_blank"
              >
                <i class="fab fa-instagram" />
              </a>
            </li>
            <li>
              <a
                v-if="hasLinkedinPage(scope.row)"
                :href="scope.row.pageUrlLinkedIn"
                class="ln"
                target="_blank"
              >
                <i class="fab fa-linkedin-in" />
              </a>
            </li>
          </ul>
        </template>
      </el-table-column>
      <el-table-column
        label="CURSOS"
        width="120"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            {{ mapTotalCourses(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="ACTIVO"
        min-width="120"
        align="center"
      >
        <template #default="scope">
          <el-switch
            v-if="scope.row.userProfile"
            v-model="scope.row.userProfile.status"
            active-color="#13ce66"
            active-text="SI"
            inactive-text="NO"
            size="small"
            :inactive-value="1"
            :active-value="2"
            @change="onChangeStatus(scope.row)"
          />
          <span v-else>—</span>
        </template>
      </el-table-column>
      <!--
      <el-table-column label="CURSO" min-width="250">
        <template slot-scope="scope">
          <div>
            {{ scope.row.curse }}
          </div>
        </template>
      </el-table-column>
      -->

      
      <el-table-column
        prop="createdAt"
        label="CREACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.createdAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="ACTUALIZACIÓN"
        :width="140"
        align="center"
      >
        <template #default="scope">
          <el-tag
            v-if="onCheckUpdatedAt(scope.row.updatedAt)"
            type="info"
            effect="plain"
          >
            <i class="el-icon-date" /> {{ formatDate(scope.row.updatedAt) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="OPCIONES"
        :width="140"
        align="center"
        text-align="center"
      >
        <template #default="scope">
          <el-dropdown @command="onChangeItemOptions">
            <el-button size="small">
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
              />
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="{ command: 'edit', item: scope.row }"
                  :disabled="!onCanRead(modulePermissions)"
                >
                  <i
                    class="el-icon-edit"
                    aria-hidden="true"
                  /> Mostrar
                </el-dropdown-item>
                <el-dropdown-item
                  :command="{ command: 'delete', item: scope.row }"
                  :disabled="!onCanDelete(modulePermissions)"
                >
                  <i
                    class="el-icon-delete"
                    aria-hidden="true"
                  /> Eliminar
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-model:current-page="currentPage"
      size="small"
      layout="prev, pager, next"
      :page-count="pagination.totalPages"
      @current-change="onPageChange"
    />
    <modal-instructor-view
      v-if="modalItem.isVisible"
      :form-data="item"
      :conf="modalItem"
      :show-status="true"
    />
    <modal-import :conf="modalImport" />
  </div>
</template>

